var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#FFE3E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_18856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_18856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4808 20.3753C10.1068 20.3753 9.78731 20.2429 9.52231 19.978C9.25744 19.713 9.125 19.3935 9.125 19.0195V9.50029H8.375V8.37529H11.75V7.71191H16.25V8.37529H19.625V9.50029H18.875V19.0195C18.875 19.3984 18.7438 19.719 18.4813 19.9815C18.2188 20.244 17.8981 20.3753 17.5192 20.3753H10.4808ZM17.75 9.50029H10.25V19.0195C10.25 19.0869 10.2716 19.1422 10.3149 19.1854C10.3581 19.2287 10.4134 19.2503 10.4808 19.2503H17.5192C17.5769 19.2503 17.6298 19.2262 17.6778 19.1781C17.7259 19.1301 17.75 19.0772 17.75 19.0195V9.50029ZM12.053 17.7503H13.1778V11.0003H12.053V17.7503ZM14.8222 17.7503H15.947V11.0003H14.8222V17.7503Z",
    fill: "#071E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.a05617081d7040d5c8932cc28bfee54c.svg";
export { ForwardRef as ReactComponent };